import React from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useTimezone } from 'libs/hooks';
import { CMembershipBalanceName, CMentoringTicketBalanceName } from 'modules/mentoring';
import { CDateFormat } from 'constants/base.const';
import { Button } from 'antd';
import styled from 'styled-components';
import { Colors, device, SecondaryColor } from 'GlobalStyles';

type TCardProps = {
  cardType: string;
  courseTitle: string;
  courseName: Array<string>;
  ticketBalance?: { [key: string]: string };
  membershipStartnDate?: string;
  buttonPath?: string;
  validDays?: number;
  endDate?: string;
};

const UserCourseTicketCard = ({
  cardType,
  courseTitle,
  courseName,
  ticketBalance,
  membershipStartnDate,
  buttonPath,
  validDays,
  endDate,
}: TCardProps) => {
  const [getDateTime, timezone] = useTimezone();
  const history = useHistory();

  return (
    <StyledTicketCard>
      <StyledTicketHeader>
        <StyledTicketTitle>{courseTitle}</StyledTicketTitle>

        <Button
          onClick={() => {
            buttonPath && history.push(buttonPath);
          }}
        >
          {cardType === 'mentoring_course_list'
            ? '수강권 구매하기'
            : courseTitle === '엑셀 강의 영상'
            ? '시청하기'
            : courseTitle === '전략컨설팅 인터뷰 MasterClass\n[기초편]'
            ? '시청하기'
            : ''}
        </Button>
      </StyledTicketHeader>
      {cardType === 'mentoring_course_list' &&
        courseName.map((el: string) => (
          <StyledTicketBody>
            <div>
              <StyledTicketName> &bull; {CMentoringTicketBalanceName[el]}</StyledTicketName>
              {/* <StyledExpirationDate>2021-12-31 만료 예정</StyledExpirationDate> */}
            </div>
            <StyledTicketRemaining>
              {(ticketBalance && Number(ticketBalance[el])) || '0'}
              <span> 회</span>
            </StyledTicketRemaining>
          </StyledTicketBody>
        ))}
      {cardType === 'membership_list' &&
        courseName.map((el: string) => (
          <StyledTicketBody>
            <div>
              <StyledTicketName> &bull; {CMembershipBalanceName[el]}</StyledTicketName>
              {membershipStartnDate && validDays && (
                <StyledExpirationDate>
                  {getDateTime(membershipStartnDate)
                    .add(validDays, 'd')
                    .format(CDateFormat)}{' '}
                  만료예정
                </StyledExpirationDate>
              )}
              {endDate && (
                <StyledExpirationDate>
                  {moment(endDate).format('YYYY-MM-DD HH:mm')} 만료예정
                </StyledExpirationDate>
              )}
            </div>
          </StyledTicketBody>
        ))}
    </StyledTicketCard>
  );
};

export default UserCourseTicketCard;

const StyledTicketCard = styled.div`
  border: 1.2px solid ${SecondaryColor};
  padding: 15px 20px;
  width: 90%;
  border-radius: 8px;
  margin-top: 5px;
  margin-bottom: 20px;
  @media screen and ${device.xs} {
    .ant-btn {
      font-size: 10px;
    }
  }
`;

const StyledTicketHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const StyledTicketTitle = styled.h1`
  margin-bottom: 0;
  white-space: pre-line;
  @media screen and ${device.xs} {
    font-size: 1.3em;
  }
`;

const StyledTicketBody = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 15px 0 10px;
`;

const StyledTicketName = styled.h3`
  margin-bottom: 0;
  white-space: pre-line;
`;

const StyledExpirationDate = styled.div`
  margin-left: 15px;
  font-size: 12px;
  color: ${Colors.grey2};
`;

const StyledTicketRemaining = styled.div`
  /* font-size: 30px; */
  font-size: 1.9em;
  font-weight: 900;
  & span {
    font-size: 15px;
  }
`;
